import styled from "styled-components";

export {
  SectionBlock,
  SectionHeader,
  SectionTitleWrapper,
  SectionTitleRow,
  SectionTitle,
  SectionSubtitle,
  InputGroup,
  Row,
  FlexInput,
  Footer,
  BackButton,
  Container,
} from "../StepRegistrationData/styles";

export const StepDescription = styled.p`
  font-size: 13.5px;
  color: var(--gray);
  margin: 0 0 16px 0;
  line-height: 1.4;
`;

export const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  color: var(--dark-gray);
  cursor: pointer;
  margin-top: 6px;
  user-select: none;

  input[type="checkbox"] {
    width: 17px;
    height: 17px;
    accent-color: var(--fixit);
    cursor: pointer;
    flex-shrink: 0;
  }
`;

export const SmoothCollapse = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? "flex" : "none")};
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e8e8e8;
`;
